import {Link} from 'react-router-dom'
import {routes} from '@/lib/routes'

/**
 * Compact link to a target-system detail page. Shared by SourcesCard and
 * AttributeAuthorityBadge so the visual treatment of "Keycloak" / "Workday" /
 * etc. stays identical wherever the system name is referenced inline.
 *
 * Forwards arbitrary `data-*` attributes so callers (e.g. the authority
 * badge) can mark up their own semantic state — `data-owned`,
 * `data-historical` — without forcing this shared link to know about them.
 */
export interface TargetSystemLinkProps {
    targetSystemId: string
    targetSystemName: string
    'data-testid'?: string
    [dataAttr: `data-${string}`]: string | undefined
}

export function TargetSystemLink({
    targetSystemId,
    targetSystemName,
    'data-testid': testId,
    ...rest
}: TargetSystemLinkProps) {
    return (
        <Link
            to={routes.systems.detail(targetSystemId)}
            className="text-xs text-primary hover:underline"
            data-testid={testId}
            {...rest}
        >
            {targetSystemName}
        </Link>
    )
}
